<template>
  <v-app>
    <div class="con-scroll-top" :class="{ active: scroll }">
      <!--스크롤시 active-->
      <button @click="scrollTop">
        <span><img src="@/assets/imgs/scroll-top.png" /></span>
      </button>
    </div>
    <v-app-bar
      class="main-top-wrap"
      app
      color="white"
      dark
      height="70px"
      style="padding: 0; z-index: 99"
      flat
    >
      <v-container class="container-header" pa-0 fluid>
        <div class="align-center logo-container" style="overflow: hidden">
          <!-- jskang 220728: 로고 이미지 변경 -->
          <img
            src="@/assets/imgs/img_logo@2x.png"
            style="cursor: pointer"
            class="logo"
            @click="goHome()"
          />
          <img
            src="@/assets/imgs/img_header_logo_54px_w@2x.png"
            style="cursor: pointer"
            class="logo m_logo"
            @click="goHome()"
          />
        </div>
        <div class="sns-logo-container menu-top-container">
          <!--          <img
            src="@/assets/imgs/facebook.png"
            style="cursor: pointer"
            class="sns-logo"
            @click="goSNS('facebook')"
          />
          <img
            src="@/assets/imgs/blog.png"
            style="cursor: pointer"
            class="sns-logo"
            @click="goSNS('blog')"
          />
          <img
            src="@/assets/imgs/insta.png"
            style="cursor: pointer"
            class="sns-logo"
            @click="goSNS('insta')"
          />-->
        <button class="container-1-btn-bottom" @click="goEnter()">
          <a>
            <div class="container-btn-bottom-text">
              간편 입점 신청
            </div>
          </a>
        </button>

        <button class="container-1-btn-bottom mr-0" @click="goOwner()">
          <a>
            <div class="container-btn-bottom-text">
              사장님 사이트 바로가기
            </div>
          </a>
        </button>

        <button class="container-1-btn-bottom mr-0" @click="goFaq()">
          <a>
            <div class="container-btn-bottom-text">
              고객지원 사이트 바로가기
            </div>
          </a>
        </button>
        </div>

        <v-spacer></v-spacer>
      </v-container>
    </v-app-bar>
    <v-main>
      <v-container fluid pa-0>
        <router-view />
      </v-container>
    </v-main>
    <v-footer color="#333333" class="dae-footer">
      <v-container class="footer-container" fluid style="margin: 0">
        <div class="footer-left">
          <img
            src="@/assets/imgs/img_logo@2x.png"
            style="cursor: pointer"
            class="bottom-daegu-logo"
          />
          <div class="dae-footer-info">
            주소: 대구광역시 서구 북비산로 369, 2층 <br />
            대표자: 최현환<br />
            사업자등록번호: 577-86-02725<br />
            <!-- jskang 220830: 사업자등록번호 수정 503-81-50051 -> 577-86-02725 -->
            통신판매업신고: 제 2005-대구서구-0304호 <br />
            <ul>
              <!-- 230130 택시 고객센터 추가로 li 문구 추가 및 수정 -->
              <li>주문 고객센터: 1661-3773</li>
              <li>팩스번호‌: 070-8220-5229</li>
            </ul>
            <div class="dae-footer-copyright">
              ‌COPYRIGHT © 20‌21 INSUNG DATA All right reserved
            </div>
            <ul class="policy-list">
              <!--              <li><button @click="goService()">서비스 이용약관</button></li>-->
              <li><button @click="goPrivacy()">개인정보처리방침</button></li>
            </ul>
          </div>
        </div>
        <!-- jskang 220818: isms 인증 항목 추가 css설정을 위해 footer-isms, footer-isms-info, isms-certification, footer-isms-info-narrow 클래스 추가, isms이미지 추가 -->
        <div class="footer-isms">
          <div class="footer-isms-info">
            <picture>
              <source
                srcset="@/assets/imgs/img_isms_c100.png"
                media="(max-width: 767px)"
              />
              <img
                src="@/assets/imgs/img_isms_w116.png"
                class="isms-certification"
              />
            </picture>
          </div>
          <div class="dae-footer-info footer-isms-info">
            정보보호 관리체계(ISMS)인증 획득<br />
            [인증범위] 인성데이타 물류솔루션 운영<br />
            (물류배송, 퀵서비스, 대리운전), 대구로 서비스<br/>
            (정보통신망법 제47조의7에 따른 인증의 특례)<br />
            [유효기간] 2025.08.03 ~ 2028.08.02 <br />
          </div>
        </div>
        <div class="footer-wrap">
          <div class="footer-btn-container">
            <a
              class="pos-btn"
              href="https://pos.daeguro.co.kr:15421/filedown/POS/ThinkPOS_Setup.exe"
            >
              POS 다운로드
            </a>
          </div>
          <div class="footer-isms-info-narrow">
            <div>
              <img
                src="@/assets/imgs/img_isms_w100.png"
                class="isms-certification"
              />
            </div>
          <div class="dae-footer-info footer-isms-info">
            정보보호 관리체계(ISMS)인증 획득<br />
            [인증범위] 인성데이타 물류솔루션 운영<br />
            (물류배송, 퀵서비스, 대리운전), 대구로 서비스<br/>
            (정보통신망법 제47조의7에 따른 인증의 특례)<br />
            [유효기간] 2025.08.03 ~ 2028.08.02 <br />
          </div>
          </div>
          <div class="footer-sns-container">
            <ul>
              <li>
                <img
                  src="@/assets/imgs/ic_youtube@2x.png"
                  class="sns-logo"
                  @click="goSNS('youtube')"
                />
              </li>
              <li>
                <img
                  src="@/assets/imgs/ic_instagram@2x.png"
                  class="sns-logo"
                  @click="goSNS('insta')"
                />
              </li>
              <li>
                <img
                  src="@/assets/imgs/ic_facebook@2x.png"
                  class="sns-logo"
                  @click="goSNS('facebook')"
                />
              </li>
              <li>
                <img
                  src="@/assets/imgs/ic_naver@2x.png"
                  class="sns-logo"
                  @click="goSNS('blog')"
                />
              </li>
              <li>
                <img
                  src="@/assets/imgs/ic_kakao@2x.png"
                  class="sns-logo"
                  @click="goSNS('kakao')"
                />
              </li>
            </ul>
          </div>
        </div>
      </v-container>
    </v-footer>
    <AppPopup
      v-for="popup in popupList"
      :key="popup.idx"
      :popup="popup"
    ></AppPopup>
  </v-app>
</template>

<script>
import AppPopup from "./components/AppPopup.vue";

export default {
  name: "App",
  components: {
    AppPopup,
  },
  data() {
    return {
      scroll: false,
      popupList: [
        {
          idx: 1,
          class: "popup-wrap popup-1",
          src: require("./assets/imgs/notice_220901_01.jpg"),
          // href: "",
        },
        {
          idx: 2,
          class: "popup-wrap popup-2",
          src: require("./assets/imgs/notice_220901_02.jpg"),
        },
        {
          idx: 3,
          class: "popup-wrap popup-3",
          src: require("./assets/imgs/hangawi_2022.jpg"),
        },
      ],
    };
  },
  created() {
    if (process.browser) {
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  destroyed() {
    if (process.browser) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    goHome() {
      if (this.$router.currentRoute.name != "Home") {
        this.$router.push({ name: "Home" });
      }
    },
    goEnter() {
      if (this.$router.currentRoute.name != "Enter_Info") {
        window.scrollTo(0, 0);
        this.$router.push({ name: "Enter_Info" });
      }
    },
    goFaq() {
      window.open("/faq/index.html");
    },    
    goOwner() {
      window.open("https://owner.daeguro.co.kr ");
    },
    goCheck() {
      if (this.$router.currentRoute.name != "User_Check") {
        this.$router.push({ name: "User_Check" });
      }
    },
    goSNS(type) {
      switch (type) {
        case "facebook":
          window.open("https://www.facebook.com/daeguro.co.kr");
          break;
        case "blog":
          window.open("https://blog.naver.com/appisdata");
          break;
        case "insta":
          window.open("https://www.instagram.com/daeguro.co.kr/");
          break;
        case "youtube":
          window.open(
            "https://www.youtube.com/channel/UCB13J3xZZSpqUO-MQkNZ3KA/"
          );
          break;
        case "kakao":
          window.open("http://pf.kakao.com/_xbdUKs");
          break;
      }
    },
    goPrivacy() {
      /*if (this.$router.currentRoute.name != "Privacy") {
        this.$router.push({ name: "Privacy" });
        window.scrollTo(0, 0);
      }*/
      window.open("https://terms.daeguro.co.kr:45028/agreement/agreement3.htm");
    },
    goService() {
      if (this.$router.currentRoute.name != "Service") {
        this.$router.push({ name: "Service" });
        window.scrollTo(0, 0);
      }
    },
    handleScroll() {
      this.scroll = window.scrollY > 500;
    },
    scrollTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
body {
  overflow-x: hidden;
}
.v-toolbar__content {
  padding: 0 !important;
}

.v-menu__content {
  z-index: 9999 !important;
}

.logo {
  height: auto;
  width: 251px;
  float: left;
}
.m_logo,
.bottom-daegu-logo {
  display: none;
}

.daegu-logo {
  width: 138px;
  float: right;
  vertical-align: middle;
  margin-top: 10px;
}

.isms-certification {
  width: 120px;
  height: 120px;
}

/* .dae-footer {
  width: 100%;
  height: 176px;
  padding: 35px 1272px 35px 375px;
} */

.footer-container {
  height: 100%;
  background-color: #333333;
  /* padding-bottom: 28px; */
}

.dae-footer-info {
  /* width: 1170px !important; */
  /*height: 100px;*/
  /* margin: 20px 0 0 375px; */
  font-family: "PretendardRegular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.24px;
  text-align: left;
  color: #ffffff;
  opacity: 0.5;
}

.dae-footer-info .footer-isms-info {
  text-align: left;
  display: inline-block;
}

.dae-footer-info ul {
  list-style: none;
  /*text-align: center;*/
  padding: 5px 0;
}

.dae-footer-info ul li {
  display: inline-block;
}

.dae-footer-info ul li:after {
  content: "|";
  display: inline-block;
  padding: 0 8px 0 10px;
  color: #ddd;
}
.dae-footer-info ul li:last-child:after {
  content: "";
}

.policy-list li:after {
  content: "" !important;
}

.policy-list li button {
  font-size: 15px;
  color: #fff;
  font-family: PretendardBold;
}

.policy-list li:hover button {
  transition: all 0.3s;
  color: #1fc7ff;
}

.policy-list li:nth-child(2) button {
  font-weight: bold;
}

.dae-footer-copyright {
  /* width: 273px; */
  /*height: 18px;*/
  /* margin: 0 0 0 375px; */
  font-family: "PretendardRegular";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.24px;
  text-align: left;
  color: #ffffff;
  margin: 10px 0;
}
/* font적용 */
@font-face {
  font-family: "NanumSquareNeoBold";
  src: url("./assets/fonts/NanumSquareNeo-cBd.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "NanumSquareNeoExtraBold";
  src: url("./assets/fonts/NanumSquareNeo-dEb.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Kopup";
  src: url("./assets/fonts/KoPubDotumMedium.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "PretendardRegular";
  src: url("./assets/fonts/Pretendard-Regular.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "PretendardMedium";
  src: url("./assets/fonts/Pretendard-Medium.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "PretendardBold";
  src: url("./assets/fonts/Pretendard-Bold.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "RobotoRegular";
  src: url("./assets/fonts/Roboto-Regular.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "GmarketSansLight";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansLight.woff")
    format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "GmarketSansMedium";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansMedium.woff")
    format("woff");
}
@font-face {
  font-family: "GmarketSansBold";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansBold.woff")
    format("woff");
}

/*popup*/
.popup-wrap .v-icon.v-icon,
.popup-wrap .theme--light.v-label {
  color: #fff;
}

@media all and (min-width: 1024px) {
  /*scroll top*/
  .con-scroll-top {
    width: 60px;
    height: 60px;
    opacity: 0;
    position: fixed;
    bottom: calc(10% - 60px);
    bottom: -webkit-calc(10% - 60px);
    right: 10%;
    z-index: 200;
    overflow: hidden;
    transition: all 0.3s;
    background: #fff;
    border: 1px solid #1fc7ff;
    border-radius: 50%;
  }
  .con-scroll-top button {
    width: 60px;
    height: 60px;
  }
  .con-scroll-top.active {
    bottom: 10%;
    transition: all 0.3s;
    opacity: 1;
  }
  .con-scroll-top img {
    width: 27px;
    height: auto;
  }

  .menu-top-container a {
    display: block;
    text-decoration: none;
    padding: 3px 5px;
    color: #3e3e3e !important;
    letter-spacing: -0.96px;
    font-size: 16px;
  }

  .menu-top-container a:hover {
    color: #1fc7ff !important;
  }

  .container-btn-bottom-text {
    font-family: "PretendardMedium";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: -1.2px;
    text-align: center;
    color: #3e3e3e;
    transition: all 0.3s;
    border: #dcdcdc solid 1px;
    border-radius: 30px;
    padding: 6px 24px;
  }
  .container-1-btn-bottom:hover .container-btn-bottom-text {
    transition: all 0.3s;
    color: #1fc7ff;
  }

  .container-header {
    width: 1280px !important;
  }
  .footer-container {
    width: 1280px !important;
    display: flex;
    justify-content: space-between;
    /* display: block; */
    /*background-image: url("assets/imgs/img_daegu_logo_white_25px@2x.png");*/
    /*background-repeat: no-repeat;*/
    /*background-position-x: center;*/
    /*background-size: 104px auto;*/
    /*background-position: right 0 bottom 35px;*/
  }
  .logo {
    margin: 25px 0 7px 35px;
    width: 330px
  }
  .v-footer {
    text-align: center;
    padding: 0 !important;
  }
  .v-footer .footer-container {
    width: 1280px !important;
    padding: 35px 55px !important;
    text-align: center;
    margin: 0 auto !important;
  }
  /*.dae-footer-copyright {*/
  /*  margin-bottom: 0 !important;*/
  /*}*/
  .sns-logo-container {
    float: right;
    margin-top: 15px;
  }
  .logo-container {
    float: left;
  }
  .sns-logo {
    width: 40px;
    height: 40px;
    margin-left: 12px;
    margin-top: 3px;
  }
  .footer-left {
    float: left;
  }
  /* 230130 dispaly flex > block */
  .footer-isms {
    display: block;
    align-items: center;
  }
  .footer-isms-info-narrow {
    display: none;
  }
  .footer-wrap {
    float: right;
    min-width: 260px;
  }
  .footer-btn-container {
    text-align: right;
  }
  .footer-sns-container {
    margin-top: 120px;
  }
  .footer-sns-container ul {
    margin: 0;
    padding: 0 !important;
    list-style: none;
    overflow: hidden;
  }
  .footer-sns-container ul li {
    background: #818181;
    border-radius: 50%;
    float: left;
    width: 40px;
    height: 40px;
    position: relative;
    margin-left: 12px;
  }
  .footer-sns-container ul li:hover {
    background: #1fc7ff;
    transition: all 0.3s;
  }
  .footer-sns-container ul li img {
    margin: 0;
    cursor: pointer;
    width: 26px;
    height: 26px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -48%);
  }
  .pos-btn {
    display: inline-block;
    border: solid 1.5px #ffffff;
    border-radius: 30px;
    padding: 4px 20px;
    font-family: "PretendardMedium";
    font-weight: 350;
    text-decoration: none;
    font-size: 20px;
    color: #fff !important;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }
}

@media all and (min-width: 768px) and (max-width: 1023px) {
  /*scroll top*/
  .con-scroll-top {
    width: 50px;
    height: 50px;
    display: none;
    opacity: 0;
    position: fixed;
    bottom: 10%;
    right: 10%;
    z-index: 200;
    transition: all 0.3s;
    background: #fff;
    border: 1px solid #1fc7ff;
    border-radius: 50%;
    padding: 11px 13px;
  }
  .con-scroll-top.active {
    transition: all 0.3s;
    display: block;
    opacity: 1;
  }
  .con-scroll-top img {
    width: 23px;
    height: auto;
  }

  /*.container-header {
    width: 768px !important;
  }
  .container-header .align-center {
    text-align: center;
  }
  .container-header .align-center .logo {
    float: none;
  }*/
  .container-header {
    width: 100% !important;
    padding: 0 55px !important;
  }

  .logo-container {
    float: left;
  }
  .menu-top-container {
    float: right;
  }
  .logo {
    float: initial !important;
    margin: 15px 0 0 40px !important;
    width: 270px;
  }
  .menu-top-container {
    margin-right: 10px;
    margin-top: 10px;
  }
  .menu-top-container a {
    display: block;
    text-decoration: none;
    padding: 5px 5px;
    color: #3e3e3e !important;
    letter-spacing: -0.96px;
    font-size: 16px;
  }

  .menu-top-container a:hover {
    color: #1fc7ff !important;
  }
  .container-btn-bottom-text {
    font-family: "PretendardMedium";
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: -1.2px;
    text-align: center;
    color: #3e3e3e;
    transition: all 0.3s;
    border: #dcdcdc solid 1px;
    border-radius: 30px;
    padding: 6px 10px;
  }
  .container-1-btn-bottom:hover .container-btn-bottom-text {
    transition: all 0.3s;
    color: #1fc7ff;
  }

  .v-footer {
    text-align: center;
    padding: 0 !important;
  }
  .v-footer .footer-container {
    width: 100% !important;
    padding: 35px 55px !important;
    text-align: center;
  }
  .footer-container {
    display: flex;
    justify-content: space-between;
    width: 586px !important;
    /* display: block; */
    text-align: center;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .footer-btn-container {
    text-align: right;
  }
  .footer-sns-container {
    display: flex;
    justify-content: right;
  }
  .footer-sns-container ul {
    margin: 0;
    padding: 0 !important;
    list-style: none;
    overflow: hidden;
  }
  .footer-sns-container ul li {
    background: #818181;
    border-radius: 50%;
    float: left;
    width: 40px;
    height: 40px;
    position: relative;
    margin-left: 12px;
  }
  .footer-sns-container ul li:hover {
    background: #1fc7ff;
    transition: all 0.3s;
  }
  .footer-sns-container ul li img {
    margin: 0;
    cursor: pointer;
    width: 26px;
    height: 26px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -48%);
  }
  .dae-footer-copyright {
    margin-bottom: 0 !important;
  }
  .sns-logo {
    width: 40px;
    height: 40px;
    margin-left: 12px;
    margin-top: 3px;
  }
  .footer-left {
    float: left;
  }
  .footer-wrap {
    float: right;
  }
  .footer-isms-info {
    display: none;
  }
  .footer-isms-info-narrow {
    display: flex;
    align-items: center;
  }
  .footer-isms-info-narrow .dae-footer-info {
    text-align: right;
  }
  /*.footer-sns-container {
     margin-top: 110px; 
  }*/
  .pos-btn {
    display: inline-block;
    border: solid 1.5px #ffffff;
    border-radius: 30px;
    padding: 4px 16px;
    font-family: "PretendardMedium";
    font-weight: 350;
    text-decoration: none;
    font-size: 20px;
    color: #fff !important;
  }
}

/*@media (max-width: 767px) {
  .container-header {
    width: 586px !important;
  }
  .footer-container {
    width: 360px !important;
    display: block;
    text-align: center;
    margin: 0 auto !important;
    padding: 10px 0;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .sns-logo-container {
    display: none;
  }
  .sns-logo {
    width: 40px;
    height: 40px;
    margin-left: 12px;
    margin-top: 3px;
  }
}*/

@media all and (max-width: 767px) {
  /*scroll top*/
  .con-scroll-top {
    width: 50px;
    height: 50px;
    display: none;
    opacity: 0;
    position: fixed;
    bottom: 12%;
    right: 10%;
    z-index: 200;
    transition: all 0.3s;
    background: #fff;
    border: 1px solid #1fc7ff;
    border-radius: 50%;
    padding: 11px 13px;
  }
  .con-scroll-top.active {
    transition: all 0.3s;
    display: block;
    opacity: 1;
  }
  .con-scroll-top img {
    width: 23px;
    height: auto;
  }

  /*로고*/
  .v-toolbar__content {
    background-color: #1fcaff;
  }
  .main-top-wrap {
    background-color: #1fc9ff;
  }
  .logo {
    display: none;
    margin: 0 auto;
  }
  .m_logo {
    float: none;
    display: block;
    margin: 0 auto;
    width: 64px;
    height: auto;
  }
  .daegu-logo {
    display: none;
    width: 138px;
    float: right;
    vertical-align: middle;
    margin-top: 10px;
  }
  /*푸터*/
  footer {
    background-color: #ffffff !important;
    margin-bottom: 67px;
  }
  .v-footer {
    padding: 0 !important;
  }
  .footer-container {
    background-color: #ffffff;
    text-align: center;
  }
  .dae-footer-info ul {
    padding: 0;
  }
  .footer-sns-container ul {
    margin: 0;
    padding: 0 !important;
    list-style: none;
    overflow: hidden;
    display: flex;
    justify-content: center;
  }
  .footer-sns-container ul li {
    background: #818181;
    border-radius: 50%;
    float: left;
    width: 46px;
    height: 46px;
    position: relative;
    margin-left: 12px;
  }
  .footer-sns-container ul li:first-child {
    margin: 0;
  }
  .footer-sns-container ul li:hover {
    background: #1fc7ff;
    transition: all 0.3s;
  }
  .footer-sns-container ul li img {
    margin: 0;
    cursor: pointer;
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -48%);
  }
  .dae-footer-info {
    background-color: #ffffff !important;
    margin-top: 40px;
  }
  .dae-footer-info {
    text-align: center !important;
    font-size: 13px;
    color: #333333;
  }
  .footer-isms {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .footer-isms-info {
    margin-top: 0px;
    display: flex;
    align-items: center;
    text-align: left !important;
  }
  .footer-isms-info-narrow {
    display: none;
  }
  .policy-list li:last-child:after {
    content: "" !important;
    padding: 0;
  }
  .policy-list li button {
    font-family: "PretendardMedium";
    font-weight: bold;
    color: #333;
  }
  .dae-footer-copyright {
    text-align: center !important;
    font-size: 10px;
    color: #333333;
  }

  .bottom-daegu-logo {
    display: block;
    width: 350px;
    height: auto;
    margin: 0 auto;
  }
  .sns-logo {
    width: 54px;
    height: 54px;
    margin: 0 7px;
  }
  .sns-logo-container {
    display: none;
  }
  .footer-sns-container {
    margin-top: 36px;
    margin-bottom: 56px;
  }
  .footer-btn-container {
    display: none;
  }
}
</style>
